import { render } from "./PageSection.vue?vue&type=template&id=0f103619&scoped=true&ts=true"
import script from "./PageSection.ts?vue&type=script&lang=ts"
export * from "./PageSection.ts?vue&type=script&lang=ts"

import "./PageSection.scss?vue&type=style&index=0&id=0f103619&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f103619"]])

export default __exports__